import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from 'reactstrap';

export interface ITwoFactorModalProps {
  show2FA: boolean;
  username: string;
  handleVerify: (code: string) => void;
  handleClose: Function;
}

interface ITwoFactorModalState {
  code: string;
}

class TwoFactorModal extends React.Component<ITwoFactorModalProps, ITwoFactorModalState> {
  state: ITwoFactorModalState = { code: '' };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ code: event.target.value });
  };

  handleSubmit = () => {
    this.props.handleVerify(this.state.code);
  };

  render() {
    const { handleClose } = this.props;

    return (
      <Modal isOpen={this.props.show2FA} toggle={handleClose} backdrop="static" autoFocus={false}>
        <ModalHeader toggle={handleClose}>Two-Factor Authentication</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="code">Enter your 2FA code</Label>
            <Input type="text" name="code" id="code" value={this.state.code} onChange={this.handleChange} autoFocus />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button color="primary" onClick={this.handleSubmit}>
            Verify
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default TwoFactorModal;
